import { render, staticRenderFns } from "./PostManager.vue?vue&type=template&id=e9ed928e&scoped=true&"
import script from "./PostManager.vue?vue&type=script&lang=js&"
export * from "./PostManager.vue?vue&type=script&lang=js&"
import style0 from "./PostManager.vue?vue&type=style&index=0&id=e9ed928e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ed928e",
  null
  
)

export default component.exports